import type { Tab } from "../routing";

// Tarifda YO'Q bo'lim butunlay yashiriladi — xira "upsell" tugmasi ham qolmaydi.
// Yashirin = yo'q: qulf belgili o'chirilgan band mahsulotni "kesilgan" qilib
// ko'rsatadi; yo'q band esa har tarifda mahsulot to'liq bo'lib tuyuladi.
//
// Qaror endi tarif NOMI bo'yicha emas, backend yuborgan `features` ro'yxati
// bo'yicha (GET /owner/tariff) — yagona manba plan_limits.py. Shu tufayli
// backend'da bayroq o'zgarsa frontendga tegilmaydi.
//
// Tab → uni ochadigan bayroq. Ro'yxatda bo'lmagan tablar (home, works, clients,
// reminders, settings, tariff) hamma tarifda bor — ular hech qachon yashirilmaydi.
const TAB_FEATURE: Partial<Record<Tab, string>> = {
  foyda_zarar: "foyda_zarar",
  qarzlar: "qarzlar",
  broadcast: "broadcast",
  tovars: "tovars",
  qaytarishlar: "tovars",
  employees: "employees",
  analytics: "analytics",
  murojaatlar: "murojaatlar",
};

// Yagona manba: sidebar (guruh sarlavhasi bilan birga) va App.tsx tab qorovuli
// ikkalasi ham shu yerdan o'qiydi. `features` hali yuklanmagan bo'lsa (null)
// hech narsa yashirilmaydi — avvalgi xatti-harakat bilan bir xil; tarif kelgach
// App.tsx effekti ochiq qolgan tabni bosh sahifaga qaytaradi.
export function hiddenTabs(
  features: readonly string[] | undefined | null,
): ReadonlySet<Tab> {
  if (!features) return new Set();
  const hidden = new Set<Tab>();
  for (const [tab, feature] of Object.entries(TAB_FEATURE)) {
    if (!features.includes(feature)) hidden.add(tab as Tab);
  }
  return hidden;
}

export function isTabHidden(
  features: readonly string[] | undefined | null,
  tab: Tab,
): boolean {
  return hiddenTabs(features).has(tab);
}
